var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.502,
    y1: 4.004,
    x2: -0.177,
    y2: 2.876,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a9fd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.014,
    y1: 1.833,
    x2: -0.486,
    y2: 2.491,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd43b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe873"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(0, -1, -0.853, 0, 4.543, 8.203)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f7f7f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_21",
    "data-name": 21,
    clipPath: "url(#clip-_21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20035",
    "data-name": "Group 20035",
    transform: "translate(-311 -112.219)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M473.249,184.768q0-7.884-4.5-8.1a8.45,8.45,0,0,0-3.491.573,5.124,5.124,0,0,0-1.833.968v12.546a8.907,8.907,0,0,0,5.1,1.675Q473.247,192.115,473.249,184.768Zm3.7.218a11.148,11.148,0,0,1-1.886,6.649,6.953,6.953,0,0,1-5.837,3.078,10.35,10.35,0,0,1-5.794-1.759v11.4l-3.216-1.147V177.9a7.186,7.186,0,0,1,2.03-1.674,13.935,13.935,0,0,1,6.977-1.717l.046.046a6.4,6.4,0,0,1,5.784,3.078A13.081,13.081,0,0,1,476.946,184.986Z",
    transform: "translate(-63.033 -13.34)",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M521.311,192.47q0,5.372-1.077,7.441a7.584,7.584,0,0,1-4.12,3.3,15.754,15.754,0,0,1-5.326,1.059l-.531-2.026a25.513,25.513,0,0,0,4.095-.792,5.408,5.408,0,0,0,3.216-2.42q.708-1.324.7-5.063v-.838a16.521,16.521,0,0,1-6.913,1.5,6.354,6.354,0,0,1-4.183-1.5,5.087,5.087,0,0,1-2.026-4.137V175.61l3.215-1.1V187.98a4.094,4.094,0,0,0,1.393,3.325,5.265,5.265,0,0,0,3.607,1.122,9.021,9.021,0,0,0,4.732-1.717V174.995h3.216Z",
    transform: "translate(-87.745 -13.34)",
    fill: "#646464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M557.922,187.17c-.383.032-.735.045-1.059.045a6.333,6.333,0,0,1-4.25-1.3,4.5,4.5,0,0,1-1.516-3.6V169.649h-2.2v-2.023h2.2v-5.373l3.212-1.143v6.516h3.613v2.023h-3.613v12.577a3.049,3.049,0,0,0,.971,2.562,4.918,4.918,0,0,0,2.642.707Z",
    transform: "translate(-111.803 -5.971)",
    fill: "#646464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M593.058,180.934h-3.215V168.522a5.872,5.872,0,0,0-.883-3.257,3.214,3.214,0,0,0-2.832-1.541q-2.211,0-5.531,2.332v14.879h-3.216V151.265l3.216-1.013v13.513a11.2,11.2,0,0,1,6.737-2.244,5.371,5.371,0,0,1,4.138,1.717,6.048,6.048,0,0,1,1.586,4.271v13.425Z",
    transform: "translate(-127.469)",
    fill: "#646464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M632.918,184.262a9.881,9.881,0,0,0-1.147-5.006,4.8,4.8,0,0,0-4.226-2.544q-5.288.306-5.284,7.571a12.453,12.453,0,0,0,1.1,5.562,4.441,4.441,0,0,0,4.243,2.8Q632.918,192.6,632.918,184.262Zm3.522.021a11.436,11.436,0,0,1-2.2,7.177,7.92,7.92,0,0,1-6.692,3.212,7.762,7.762,0,0,1-6.607-3.212,11.59,11.59,0,0,1-2.157-7.177,10.247,10.247,0,0,1,2.333-6.825,8.037,8.037,0,0,1,6.473-2.948,8.172,8.172,0,0,1,6.519,2.948A10.247,10.247,0,0,1,636.439,184.283Z",
    transform: "translate(-150.237 -13.34)",
    fill: "#646464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M679.982,194.274h-3.216V181.159a4.387,4.387,0,0,0-1.3-3.37,4.713,4.713,0,0,0-3.458-1.165,7.737,7.737,0,0,0-4.36,1.5v16.156h-3.215V177.721a15.836,15.836,0,0,1,5.108-2.638,15.57,15.57,0,0,1,3.878-.574,10.042,10.042,0,0,1,2.156.222,6.2,6.2,0,0,1,3.082,1.629,4.31,4.31,0,0,1,1.323,3.17Z",
    transform: "translate(-175.345 -13.34)",
    fill: "#646464"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path1948",
    d: "M365.421,152.767a27.667,27.667,0,0,0-4.625.395c-4.095.724-4.839,2.238-4.839,5.031v3.689h9.678v1.23h-13.31a6.043,6.043,0,0,0-6.046,4.906,18.094,18.094,0,0,0,0,9.836c.688,2.865,2.331,4.906,5.144,4.906h3.328v-4.422a6.15,6.15,0,0,1,6.046-6.012h9.667a4.876,4.876,0,0,0,4.839-4.918v-9.216c0-2.622-2.212-4.593-4.839-5.031A30.186,30.186,0,0,0,365.421,152.767Zm-5.234,2.966a1.845,1.845,0,1,1-1.816,1.85A1.836,1.836,0,0,1,360.186,155.733Z",
    transform: "translate(0 -1.383)",
    fill: "url(#linear-gradient)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path1950",
    d: "M389.167,175.75v4.3a6.207,6.207,0,0,1-6.046,6.136h-9.667a4.937,4.937,0,0,0-4.839,4.918v9.216c0,2.622,2.281,4.166,4.839,4.918a16.189,16.189,0,0,0,9.667,0c2.436-.705,4.839-2.125,4.839-4.918v-3.689h-9.667V195.4H392.8c2.813,0,3.861-1.962,4.839-4.906,1.01-3.032.968-5.947,0-9.836-.695-2.8-2.023-4.906-4.839-4.906Zm-5.437,23.338a1.844,1.844,0,1,1-1.816,1.838A1.827,1.827,0,0,1,383.73,199.088Z",
    transform: "translate(-12.659 -14.023)",
    fill: "url(#linear-gradient-2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "text3004",
    d: "M711.262,164.382h.564v-3.536h1.335v-.422h-3.235v.422h1.336v3.536m2.4,0h.482v-3.23l1.045,3.229h.536l1.09-3.218v3.219h.525v-3.958h-.7l-1.19,3.391-1.016-3.391h-.777v3.958",
    transform: "translate(-200.363 -5.594)",
    fill: "#646464"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1894",
    d: "M387.485,252.112c0,1.389-5.807,2.514-12.97,2.514s-12.969-1.126-12.969-2.514,5.807-2.515,12.969-2.515S387.485,250.723,387.485,252.112Z",
    transform: "translate(-8.771 -54.635)",
    opacity: 0.444,
    fill: "url(#radial-gradient)",
    style: {
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython2);
export default __webpack_public_path__ + "static/media/python-2.d4a0368395e8591e840dd2b39802660f.svg";
export { ForwardRef as ReactComponent };